/* The old hub: everything not tied to a school type or a subject — theory, the
   planning method, the prompt database, the tools. It is itself a document, so
   it is content and not code.
   OWNED BY THE FOUNDATION. */

import { DocPage } from "./DocPage";

export function Overview() {
  return <DocPage id="prehled" />;
}
